import { Dropdown, Icon } from '@shinetools/lumen-react'
import { PlusIcon, UploadIcon } from 'lucide-react'
import { ReactElement, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { ExpensesTrackingEvents } from '@views/receipts/enums/tracking'

import { useOrganizationViewUrl } from '../../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { useSegment } from '../../../../../../../../../hooks/useSegment'
import { reactRoute } from '../../../../../../../../../utils/routing/reactRoute'

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const BillsListHeaderActionCreatePurchase = (): ReactElement => {
  const { track } = useSegment()
  const navigate = useNavigate()
  const { url: newBillUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getNewBillRoute())
  const { url: newCreditNoteUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getNewCreditNoteRoute())

  const handleCreateBillClick = useCallback(() => {
    if (!newBillUrl) {
      return
    }

    track(ExpensesTrackingEvents.CreatePurchaseClicked, {
      source: 'Main CTA - Purchase page',
    })
    navigate(newBillUrl)
  }, [track, navigate, newBillUrl])

  const handleCreateCreditNoteClick = useCallback(() => {
    if (!newCreditNoteUrl) {
      return
    }

    track(ExpensesTrackingEvents.CreateCreditNoteClicked, {
      source: 'Main CTA - Purchase page',
    })
    navigate(newCreditNoteUrl)
  }, [track, navigate, newCreditNoteUrl])

  return (
    <Dropdown label="Add purchase" size="medium">
      {/**
       * @todo Add upload handling
       * @see https://linear.app/shine-co/issue/EXP-315/web-add-upload-header-buttons
       */}
      <Dropdown.Item icon={<Icon icon={UploadIcon} />} label="Upload from computer" />

      <Dropdown.Item
        onClick={handleCreateBillClick}
        icon={<Icon icon={PlusIcon} />}
        label="Create a purchase manually"
      />

      <Dropdown.Item
        onClick={handleCreateCreditNoteClick}
        icon={<Icon icon={PlusIcon} />}
        label="Create a credit note manually"
      />
    </Dropdown>
  )
}
